const { logger } = require('@fiverr-private/obs');
const { DOMAIN_ERROR_PREFIX } = require('./constants');

const logAPIError = (exception = {}, enrichment = {}) => {
    const { message } = exception;

    const stackResult = {};
    Error.captureStackTrace(stackResult, logAPIError);

    logger.error({
        ...exception,
        message: `${DOMAIN_ERROR_PREFIX} ${message}`
    },
    {
        ...enrichment,
        trace: stackResult.stack
    });
};

module.exports = {
    logAPIError,
    DOMAIN_ERROR_PREFIX
};
